import React from "react";
import "./Switch.scss";

export default function Switch({ checked, name, onChange, valueType = "string" }) {
    // Normalize incoming value to boolean for UI
    const isChecked = checked === 1 || checked === "1" || checked === true;

    return (
        <div className="position-relative ultimate-security-switcher">
            <label>
                <input
                    data-checked={isChecked}
                    name={name}
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => {
                        // Return value based on specified type
                        const newValue = e.target.checked;
                        if (valueType === "string") {
                            onChange(name, newValue ? "1" : "0");
                        } else {
                            onChange(name, newValue ? 1 : 0);
                        }
                    }}
                />
                <em data-on="Active" data-off="Inactive"></em>
                <span></span>
            </label>
        </div>
    );
}





